<div class="start mt-5 mb-16 w-full px-6 py-4 md:px-16">
  @if (canSeeProducts()) {
    <div class="flex flex-col items-stretch justify-start gap-10">
      <div class="border-b border-border-secondary pb-6">
        <h1
          class="mt-5 mb-2 bg-linear-to-b from-gradient-start from-0% via-gradient-middle2 via-50% to-gradient-end to-100% bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
        >
          {{ 'pages.pricing.title' | translate }}
        </h1>
        <div class="mb-10 text-lg leading-normal font-normal text-neutral-500">
          {{ 'pages.pricing.subtitle' | translate }}
        </div>

        <div class="flex" *dhpFeature="'SUBSCRIPTION_SELF_SERVICE'">
          @if (isReseller()) {
            <dhp-organization-dropdown-filter
              (selectedOrganizationId)="onSelectedOrganizationIdChange($event)"
            />
          }
          <span class="flex-1"></span>
          <button
            class="btn-primary btn"
            [disabled]="!hasSelectedProducts()"
            (click)="navigateToProductBasket()"
          >
            {{ 'pages.pricing.continueCheckout' | translate }}
          </button>
        </div>
      </div>
      @if (!isReseller() || selectedOrganizationId()) {
        <div
          class="flex flex-col gap-16"
          *dhpFeature="'SUBSCRIPTION_SELF_SERVICE'; else noFeature"
        >
          @if (products(); as products) {
            @for (
              type of ['package', 'magazine', 'misc', 'content_integrator'];
              track type
            ) {
              @if ((products | filterBy: ['productType'] : type).length > 0) {
                <div>
                  <h4 class="mb-2 text-4xl">
                    {{ 'pages.pricing.type.' + type | translate }}
                  </h4>
                  @let availableProducts =
                    this.availableProducts() ?? []
                      | filterBy: ['productType'] : type;
                  @if (availableProducts.length > 0) {
                    <div
                      class="grid grid-cols-1 gap-8 lg:grid-cols-2 2xl:grid-cols-3"
                    >
                      @for (
                        product of availableProducts | orderBy: ['name'];
                        track product.id
                      ) {
                        <dhp-product-card
                          [product]="product"
                          [seats]="getSelectedUsers(product.id)"
                          [minSelected]="getMinSelected(product)"
                          (seatsChange)="onSelectedUsersChange(product, $event)"
                        ></dhp-product-card>
                      }
                    </div>
                  } @else {
                    <span class="text-text-secondary italic">
                      {{
                        'pages.pricing.noProductsOfType'
                          | translate
                            : {
                                type:
                                  ('pages.pricing.type.' + type
                                  | translate
                                  | lowercase),
                              }
                      }}
                    </span>
                  }
                </div>
              }
            }
          } @else {
            <div>
              <p class="text-center text-lg font-normal text-neutral-500">
                {{ 'pages.pricing.loadingProducts' | translate }}
              </p>
            </div>
          }
          <div class="mt-6 flex justify-end">
            <button
              class="btn-primary btn"
              [disabled]="!hasSelectedProducts()"
              (click)="navigateToProductBasket()"
            >
              {{ 'pages.pricing.continueCheckout' | translate }}
            </button>
          </div>
        </div>
        <ng-template #noFeature>
          <p class="py-2">
            {{ 'pages.pricing.introduction' | translate }}
          </p>
          <p class="py-2">
            <a
              class="hover:underline"
              href="mailto:websupport@denhollander.info"
            >
              <strong>{{ 'websupport&commat;denhollander.info' }}</strong>
            </a>
          </p>
        </ng-template>
      } @else {
        <div class="mt-10" *dhpFeature="'SUBSCRIPTION_SELF_SERVICE'">
          @if (isReseller()) {
            <p
              class="mt-4 text-base leading-normal font-normal text-neutral-800"
            >
              {{ 'pages.pricing.resellerInfo' | translate }}
            </p>
          }
        </div>
      }
    </div>
  } @else if (!hasOrganization()) {
    <div class="container flex flex-col items-center justify-start gap-4">
      <p>
        {{ 'pages.pricing.noOrganization' | translate }}
      </p>
      <button class="btn-primary btn" (click)="createOrganization()">
        {{ 'pages.organization.linkedRelation.createOrganization' | translate }}
      </button>
    </div>
  } @else {
    <div class="container flex flex-col items-start justify-start gap-4">
      <p>
        {{ 'pages.pricing.noBillingAdmin' | translate }}
      </p>
      @if (hasOrganization()) {
        <div class="mt-2 rounded-2xl border border-secondary-border p-8">
          <div class="flex flex-col gap-6">
            <!-- Organization Name-->
            <dhp-information-field
              [labelKey]="'pages.organization.profile.businessProfile.companyName'"
            >
              <span>{{ organization()?.name ?? '-' }}</span>
            </dhp-information-field>
            <dhp-information-field
              [labelKey]="'pages.organization.profile.linkedRelation.contactPerson'"
            >
              @if (organization()?.billingAdmins?.docs?.[0]) {
                <span>
                  {{ organization()?.billingAdmins?.docs?.[0]?.name ?? '' }}
                </span>
                <span>
                  {{ organization()?.billingAdmins?.docs?.[0]?.email ?? '' }}
                </span>
              } @else {
                {{
                  'pages.organization.profile.linkedRelation.missingBillingAdmin'
                    | translate
                }}
              }
            </dhp-information-field>
          </div>
        </div>
      }
    </div>
  }
</div>
